(() => {
  if (window.CloudyFiltersInitialized) {
    return;
  }
  window.CloudyFiltersInitialized = true;

  $(document).ready(function () {
    let productItems = $('.product-item');
    const urlFilterState = {
      availability: null,
      price: {
        min: null,
        max: null,
      },
      filters: {},
    };
    const queryParamMap = {
      category: ['filter.p.m.my_fields.category'],
      brand: ['filter.p.vendor'],
      size: ['filter.v.option.size'],
    };
    const priceFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    function normalizeFilterValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');
    }

    function clampValue(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getNormalizedParamValues(params, keys) {
      const values = [];

      keys.forEach(key => {
        params.getAll(key).forEach(rawValue => {
          String(rawValue || '')
            .split(',')
            .forEach(part => {
              const normalized = normalizeFilterValue(part);
              if (normalized && !values.includes(normalized)) {
                values.push(normalized);
              }
            });
        });
      });

      return values;
    }

    function syncFiltersFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const minInput = $('#min-price');
      const maxInput = $('#max-price');
      const minBound = Number(minInput.attr('min')) || 0;
      const maxBound = Number(maxInput.attr('max')) || 999999;
      const minParam = parseInt(params.get('filter.v.price.gte'), 10);
      const maxParam = parseInt(params.get('filter.v.price.lte'), 10);

      if (minInput.length && Number.isFinite(minParam)) {
        const clampedMin = clampValue(minParam, minBound, maxBound);
        minInput.val(clampedMin);
        urlFilterState.price.min = clampedMin;
      }

      if (maxInput.length && Number.isFinite(maxParam)) {
        const clampedMax = clampValue(maxParam, minBound, maxBound);
        maxInput.val(clampedMax);
        urlFilterState.price.max = clampedMax;
      }

      Object.entries(queryParamMap).forEach(([filterName, keys]) => {
        const selectedValues = getNormalizedParamValues(params, keys);
        urlFilterState.filters[filterName] = selectedValues;
        if (!selectedValues.length) return;

        $(`.filter-group[data-filter="${filterName}"] input[type="checkbox"]`).each(function () {
          const checkbox = $(this);
          const checkboxValue = normalizeFilterValue(checkbox.val());
          checkbox.prop('checked', selectedValues.includes(checkboxValue));
        });
      });

      const availabilityParam = params.get('filter.v.availability');
      if (availabilityParam === '1') {
        urlFilterState.availability = true;
      } else if (availabilityParam === '0') {
        urlFilterState.availability = false;
      } else {
        urlFilterState.availability = null;
      }
    }

    function updateCollectionDivider() {
      const body = document.body;
      if (!body.classList.contains('template-collection')) return;

      const sidebar = document.querySelector('.section-collection-main .filter-sidebar');
      const mainSection = document.querySelector('.section-collection-main');

      if (!sidebar || !mainSection || window.innerWidth <= 768) {
        body.style.setProperty('--collection-divider-left', '-9999px');
        body.style.setProperty('--collection-divider-height', '0px');
        return;
      }

      const sidebarRect = sidebar.getBoundingClientRect();
      const mainRect = mainSection.getBoundingClientRect();
      const scrollY = window.scrollY || window.pageYOffset;

      const dividerLeft = Math.round(sidebarRect.right + (window.scrollX || window.pageXOffset || 0));
      const dividerTop = Math.round(mainRect.top + scrollY);
      const dividerBottom = Math.round(mainRect.bottom + scrollY);
      const dividerHeight = Math.max(0, dividerBottom - dividerTop);

      body.style.setProperty('--collection-divider-left', `${dividerLeft}px`);
      body.style.setProperty('--collection-divider-top', `${dividerTop}px`);
      body.style.setProperty('--collection-divider-height', `${dividerHeight}px`);
    }

    function updateDesktopStickySidebar() {
      const section = document.querySelector('.section-collection-main');
      const layout = section ? section.querySelector('.collection-layout') : null;
      const sidebar = layout ? layout.querySelector('.filter-sidebar') : null;

      if (!section || !layout || !sidebar) return;

      if (window.innerWidth <= 991) {
        sidebar.classList.remove('is-sticky-active', 'is-sticky-bottom');
        sidebar.style.removeProperty('--collection-sticky-left');
        sidebar.style.removeProperty('--collection-sticky-width');
        sidebar.style.removeProperty('--collection-sticky-top');
        return;
      }

      const header = document.querySelector('.site-header--sticky.is-sticky-active');
      const headerOffset = header ? header.getBoundingClientRect().height : 0;
      const stickyTop = headerOffset > 0 ? headerOffset + 8 : 24;
      const sectionRect = section.getBoundingClientRect();
      const layoutRect = layout.getBoundingClientRect();
      const sidebarHeight = sidebar.offsetHeight;
      const sidebarWidth = sidebar.offsetWidth;
      const shouldStick = sectionRect.top <= stickyTop && sectionRect.bottom > stickyTop + sidebarHeight;
      const shouldPinBottom = sectionRect.top <= stickyTop && sectionRect.bottom <= stickyTop + sidebarHeight;

      sidebar.style.setProperty('--collection-sticky-left', `${Math.round(layoutRect.left)}px`);
      sidebar.style.setProperty('--collection-sticky-width', `${Math.round(sidebarWidth)}px`);
      sidebar.style.setProperty('--collection-sticky-top', `${Math.round(stickyTop)}px`);

      sidebar.classList.toggle('is-sticky-active', shouldStick);
      sidebar.classList.toggle('is-sticky-bottom', !shouldStick && shouldPinBottom);
    }

    function filterProducts() {
      productItems = $('.product-item');
      if (!productItems.length) return;
      const minInput = $('#min-price');
      const maxInput = $('#max-price');
      const minPrice = minInput.length
        ? parseInt(minInput.val(), 10) || 0
        : (urlFilterState.price.min ?? 0);
      const maxPrice = maxInput.length
        ? parseInt(maxInput.val(), 10) || 999999
        : (urlFilterState.price.max ?? 999999);

      const activeFilters = {
        price: { min: minPrice, max: maxPrice },
      };

      $('.filter-group[data-filter]').each(function () {
        const filterName = $(this).data('filter');
        activeFilters[filterName] = [];

        $(this)
          .find('input[type="checkbox"]:checked')
          .each(function () {
            const val = $(this).val();
            if (val) activeFilters[filterName].push(normalizeFilterValue(val));
          });
      });

      Object.keys(queryParamMap).forEach(filterName => {
        const filterGroupExists = $(`.filter-group[data-filter="${filterName}"]`).length > 0;
        if (!filterGroupExists && urlFilterState.filters[filterName]?.length) {
          activeFilters[filterName] = [...urlFilterState.filters[filterName]];
        }
      });

      productItems.each(function () {
        const product = $(this);
        let show = true;

        const price = parseInt(product.data('price'), 10);
        if (price < activeFilters.price.min || price > activeFilters.price.max) {
          show = false;
        }

        if (show && urlFilterState.availability !== null) {
          const isAvailable = String(product.data('available')) === 'true';
          if (isAvailable !== urlFilterState.availability) {
            show = false;
          }
        }

        for (const filter in activeFilters) {
          if (filter === 'price') continue;

          if (activeFilters[filter].length > 0) {
            const dataValue = product.data(filter);
            if (!dataValue) {
              show = false;
              break;
            }

            const productValues = String(dataValue)
              .split(',')
              .map(v => normalizeFilterValue(v))
              .filter(Boolean);

            const match = activeFilters[filter].some(val =>
              productValues.includes(val)
            );

            if (!match) {
              show = false;
              break;
            }
          }
        }

        product.toggle(show);
      });
    }

    $(document).on('change', '.filter-group input[type="checkbox"]', filterProducts);

    $('#min-price, #max-price').on('input', function () {
      $('#min-price-value').text(priceFormatter.format(Number($('#min-price').val()) || 0));
      $('#max-price-value').text(priceFormatter.format(Number($('#max-price').val()) || 0));
      filterProducts();
    });

    $(document).on('click', '.filter-toggle', function () {
      const trigger = $(this);
      const group = trigger.closest('.filter-group');
      const options = trigger.next('.filter-options');
      const isOpen = group.hasClass('is-open');

      group.toggleClass('is-open', !isOpen);
      trigger.attr('aria-expanded', !isOpen ? 'true' : 'false');

      if (!options.length) return;

      if (isOpen) {
        options.stop(true, true).slideUp(180);
      } else {
        options.stop(true, true).slideDown(180, function () {
          if (options.hasClass('filter-options--price')) {
            options.css('display', 'block');
          } else {
            options.css('display', 'grid');
          }
        });
      }
    });

    function syncPriceSliders() {
      const minInput = $('#min-price');
      const maxInput = $('#max-price');

      let minVal = parseInt(minInput.val(), 10);
      let maxVal = parseInt(maxInput.val(), 10);

      if (minVal > maxVal) {
        [minVal, maxVal] = [maxVal, minVal];
        minInput.val(minVal);
        maxInput.val(maxVal);
      }

      $('#min-price-value').text(priceFormatter.format(minVal));
      $('#max-price-value').text(priceFormatter.format(maxVal));

      const minBound = Number(minInput.attr('min')) || 0;
      const maxBound = Number(minInput.attr('max')) || 0;
      const range = maxBound - minBound || 1;
      const left = ((minVal - minBound) / range) * 100;
      const right = 100 - ((maxVal - minBound) / range) * 100;

      $('.price-slider').css({
        '--left': `${left}%`,
        '--right': `${right}%`,
      });
    }

    $('#min-price, #max-price').on('input', syncPriceSliders);

    function syncNativePriceRangeForms() {
      const nativePriceForms = document.querySelectorAll('.price-filter-form');

      nativePriceForms.forEach(form => {
        const slider = form.querySelector('.price-slider--native');
        if (!slider) return;

        const minRange = slider.querySelector('.native-price-range--min');
        const maxRange = slider.querySelector('.native-price-range--max');
        const minHidden = form.querySelector('.native-price-hidden--min');
        const maxHidden = form.querySelector('.native-price-hidden--max');
        const minLabel = form.querySelector('.native-price-display--min');
        const maxLabel = form.querySelector('.native-price-display--max');

        if (!minRange || !maxRange || !minHidden || !maxHidden || !minLabel || !maxLabel) return;

        const minBound = Number(minRange.min) || 0;
        const maxBound = Number(minRange.max) || 0;
        const range = maxBound - minBound || 1;

        const update = source => {
          let minVal = parseInt(minRange.value, 10);
          let maxVal = parseInt(maxRange.value, 10);

          if (minVal > maxVal) {
            if (source === 'min') {
              maxVal = minVal;
              maxRange.value = maxVal;
            } else {
              minVal = maxVal;
              minRange.value = minVal;
            }
          }

          minHidden.value = minVal > minBound ? String(minVal) : '';
          maxHidden.value = maxVal < maxBound ? String(maxVal) : '';
          minLabel.textContent = priceFormatter.format(minVal);
          maxLabel.textContent = priceFormatter.format(maxVal);

          const left = ((minVal - minBound) / range) * 100;
          const right = 100 - ((maxVal - minBound) / range) * 100;

          slider.style.setProperty('--left', `${left}%`);
          slider.style.setProperty('--right', `${right}%`);
        };

        const submitForm = () => {
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        };

        minRange.addEventListener('input', () => update('min'));
        maxRange.addEventListener('input', () => update('max'));
        minRange.addEventListener('change', submitForm);
        maxRange.addEventListener('change', submitForm);

        update();
      });
    }

    window.CloudyFiltersApply = filterProducts;
    window.CloudyCollectionDividerUpdate = updateCollectionDivider;
    window.CloudyCollectionStickyUpdate = updateDesktopStickySidebar;
    $('.filter-group.is-open .filter-toggle').attr('aria-expanded', 'true');
    syncFiltersFromUrl();
    filterProducts();
    syncPriceSliders();
    syncNativePriceRangeForms();
    updateCollectionDivider();
    updateDesktopStickySidebar();

    window.addEventListener('resize', updateCollectionDivider);
    window.addEventListener('load', updateCollectionDivider);
    window.addEventListener('resize', updateDesktopStickySidebar);
    window.addEventListener('load', updateDesktopStickySidebar);
    window.addEventListener('scroll', updateDesktopStickySidebar, { passive: true });

    if ('ResizeObserver' in window) {
      const observedTargets = [
        document.querySelector('.section-collection-main'),
      ].filter(Boolean);

      if (observedTargets.length) {
        const dividerObserver = new ResizeObserver(() => {
          updateCollectionDivider();
          updateDesktopStickySidebar();
        });
        observedTargets.forEach(target => dividerObserver.observe(target));
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const openBtn = document.getElementById('openFilters');
    const closeBtn = document.getElementById('closeFilters');
    const sidebar = document.querySelector('.filter-sidebar');
    const overlay = document.querySelector('.filter-sidebar-overlay');

    if (!openBtn || !closeBtn || !sidebar) return;

    function setFiltersOpen(isOpen) {
      sidebar.classList.toggle('active', isOpen);
      sidebar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (overlay) {
        overlay.classList.toggle('active', isOpen);
        overlay.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      }
      document.body.classList.toggle('collection-filters-open', isOpen);
    }

    function syncFilterDrawerState() {
      if (window.innerWidth > 991) {
        sidebar.classList.remove('active');
        sidebar.setAttribute('aria-hidden', 'false');
        openBtn.setAttribute('aria-expanded', 'false');
        if (overlay) {
          overlay.classList.remove('active');
          overlay.setAttribute('aria-hidden', 'true');
        }
        document.body.classList.remove('collection-filters-open');
      } else if (!sidebar.classList.contains('active')) {
        sidebar.setAttribute('aria-hidden', 'true');
        openBtn.setAttribute('aria-expanded', 'false');
        if (overlay) {
          overlay.classList.remove('active');
          overlay.setAttribute('aria-hidden', 'true');
        }
        document.body.classList.remove('collection-filters-open');
      }
    }

    openBtn.addEventListener('click', function () {
      setFiltersOpen(true);
    });

    closeBtn.addEventListener('click', function () {
      setFiltersOpen(false);
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        setFiltersOpen(false);
      });
    }

    document.addEventListener('click', function (e) {
      if (!sidebar.contains(e.target) && !openBtn.contains(e.target)) {
        setFiltersOpen(false);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        setFiltersOpen(false);
      }
    });

    syncFilterDrawerState();
    window.addEventListener('resize', syncFilterDrawerState);
  });

  document.addEventListener('DOMContentLoaded', function () {
    const viewControls = document.querySelector('.view-controls');
    const productList = document.getElementById('product-list');

    if (!viewControls || !productList) return;

    const buttons = viewControls.querySelectorAll('button[data-view]');

    function setView(view) {
      const isList = view === 'list';
      productList.classList.toggle('card-view', !isList);
      productList.classList.toggle('list-view', isList);

      buttons.forEach(btn => {
        const isActive = btn.dataset.view === view;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      try {
        localStorage.setItem('collectionView', view);
      } catch (error) {}
    }

    if (window.getComputedStyle(viewControls).display === 'none') {
      setView('grid');
      return;
    }

    buttons.forEach(btn => {
      btn.addEventListener('click', function () {
        setView(this.dataset.view);
      });
    });

    let storedView = null;
    try {
      storedView = localStorage.getItem('collectionView');
    } catch (error) {}

    if (storedView === 'list' || storedView === 'grid') {
      setView(storedView);
    } else {
      setView('grid');
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    const sectionWrapper = document.querySelector('.section-collection-main');
    const section = sectionWrapper
      ? sectionWrapper.querySelector('[data-infinite-scroll]')
      : document.querySelector('[data-infinite-scroll]');

    if (!section || section.dataset.infiniteScroll !== 'true') return;

    const productList = document.getElementById('product-list');
    const infiniteWrap = section.querySelector('.collection-infinite[data-infinite-scroll="true"]');

    if (!productList || !infiniteWrap) return;

    let nextUrl =
      infiniteWrap.dataset.nextUrl ||
      section.querySelector('.pagination .next a')?.getAttribute('href') ||
      '';
    const mode = infiniteWrap.dataset.scrollMode || 'auto';
    const button = infiniteWrap.querySelector('.load-more-btn');
    const status = infiniteWrap.querySelector('.infinite-status');
    let loading = false;

    function setStatus(message) {
      if (status) status.textContent = message;
    }

    async function loadNext() {
      if (loading || !nextUrl) return;
      loading = true;
      infiniteWrap.classList.add('is-loading');
      setStatus('');

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Failed to load');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        doc.querySelectorAll('#product-list .product-item').forEach(item => {
          productList.appendChild(item);
        });

        const nextFromInfinite = doc.querySelector('.collection-infinite[data-next-url]');
        const nextLink = doc.querySelector('.pagination .next a');
        nextUrl = nextFromInfinite?.dataset?.nextUrl || (nextLink ? nextLink.getAttribute('href') : '');

        if (!nextUrl) {
          infiniteWrap.classList.add('is-end');
          if (button) {
            button.disabled = true;
            button.style.display = 'none';
          }
        } else {
          if (button) button.disabled = false;
          setStatus('');
        }

        if (typeof window.CloudyFiltersApply === 'function') {
          window.CloudyFiltersApply();
        }
        if (typeof window.CloudyCollectionDividerUpdate === 'function') {
          window.CloudyCollectionDividerUpdate();
        }
        if (typeof window.CloudyCollectionStickyUpdate === 'function') {
          window.CloudyCollectionStickyUpdate();
        }
      } catch (error) {
        setStatus('');
      } finally {
        infiniteWrap.classList.remove('is-loading');
        loading = false;
      }
    }

    if (mode === 'manual' && button) {
      button.addEventListener('click', loadNext);
    } else if (mode === 'auto') {
      if (button) button.style.display = 'none';

      const sentinel = document.createElement('div');
      sentinel.className = 'infinite-sentinel';
      infiniteWrap.appendChild(sentinel);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            loadNext();
          }
        }, { rootMargin: '200px 0px' });

        observer.observe(sentinel);
      }
    }
  });
})();
